import { apiSlice } from '@src/services/api/apiSlice';
import { Role } from '../roleTypes';
import { EditRoleParams } from './editRoleApiSliceTypes';

const editRoleApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        editRole: builder.mutation<Role, EditRoleParams>({
            query: ({ roleId, ...body }) => ({
                url: `/roles/${roleId}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: [{ type: 'roles', id: 'LIST' }],
        }),
    }),
    overrideExisting: true,
});

export const { useEditRoleMutation } = editRoleApiSlice;
